import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseButton, useT } from '@repo/common';

/**
 * 목록 중간에 노출되는 채용 담당자용 배너.
 */
const HiringBanner = ({ className = '' }) => {
  const t = useT();
  const navigate = useNavigate();

  const goToBusinessSignUp = () => {
    navigate('/register', { state: { accountType: 'business' } });
  };

  return (
    <div
      role='button'
      tabIndex={0}
      onClick={goToBusinessSignUp}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          goToBusinessSignUp();
        }
      }}
      className={`
        flex w-full shrink-0 cursor-pointer items-center justify-between gap-2
        rounded-[15px] border border-grayscale-gray02 bg-grayscale-gray00
        px-6 py-[18px] transition-colors duration-200
        tabletH:rounded-lg tabletH:p-6
        ${className}
      `}
    >
      <p className='typo-b16Strong tabletH:typo-title3 min-w-0 flex-1 text-text-primary'>
        {t('Hiring? Post a job', '채용 중이신가요? 공고를 등록하세요')}
      </p>

      <BaseButton
        type='text_basic'
        size='m'
        hideIcon
        bgclass='shrink-0 bg-grayscale-gray01 text-grayscale-gray07 border-none'
        onClick={(e) => {
          e.stopPropagation();
          goToBusinessSignUp();
        }}
      >
        {t('Start free', '무료로 시작하기')}
      </BaseButton>
    </div>
  );
};

export default HiringBanner;
